import { SelectMediaCategoryType } from '@wix/editor-platform-sdk-types';
import { Data } from '@wix/component-protocol/schema';

import { PlatformPrivateServices } from '../../../PlatformPrivateServices';

interface ISelectMediaParamsByItemKey {
  dataItemKey: string;
}

interface ISelectMediaParamsByOptions {
  // TODO: type should be the updated category options type once it is well defined https://wix.atlassian.net/browse/EP-6442
  category?: SelectMediaCategoryType;
  isMultiSelect?: boolean;
}

export type ISelectMediaParams =
  | ISelectMediaParamsByItemKey
  | ISelectMediaParamsByOptions;

// TODO: expand categories according to manifest and property options https://wix.atlassian.net/browse/EP-6442
const MEDIA_CATEGORY_MAP: Record<string, SelectMediaCategoryType> = {
  image: 'IMAGE',
  video: 'VIDEO',
  vectorArt: 'SHAPE_ALL',
};

export class HostMediaSelectorAPI {
  constructor(private ps: PlatformPrivateServices) {}

  async selectMedia(
    dataItemKey: string,
    context: {
      dataDefinitions: Data;
      data: Record<string, unknown>;
    },
  ) {
    const definition = context.dataDefinitions[dataItemKey];

    // TODO: base mediaCategory on manifest as well https://wix.atlassian.net/browse/EP-6442
    const category =
      MEDIA_CATEGORY_MAP[
        definition?.dataType as keyof typeof MEDIA_CATEGORY_MAP
      ] ?? 'ALL_MEDIA';

    return this.ps.hostAPI.editor.selectMedia({
      // TODO: type should be the updated category options type once it is well defined https://wix.atlassian.net/browse/EP-6442
      category,
    });
  }
}
